
import React, { useState } from 'react';
import {
    Box,
    Button,
    Typography,
    Dialog,
    DialogContent,
    IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch } from 'react-redux';
import actions from '../../../ReduxStore/actions';
import { adminUrl } from '../../../constants';

const FileUploadWithPreview = ({ setUploadedFiles, uploadedFiles, getKraKpiAppraisalForm }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const dispatch = useDispatch();

    const handleFileChange = async (event) => {
        const files = Array.from(event.target.files);
        const formData = new FormData();

        files?.forEach((file) => {
            formData?.append("uploadFiles", file);
        });

        const data1 = {
            data: formData,
            method: "post",
            apiName: "multiplefiles",
        };

        try {
            const responseData = await dispatch(actions.UPLOADPDFANDIMAGE(data1));
            if (responseData?.payload?.message === "Files uploaded successfully!") {
                if (responseData?.payload?.data?.files) {
                    setUploadedFiles(prev => [...(Array.isArray(prev) ? prev : []), ...responseData?.payload?.data?.files]);
                }
            }
        } catch (error) {
            console.error("File upload failed", error);
        }
    };

    const handlePreviewClick = (file, type) => {
        const fullUrl = `${adminUrl}${file.fileUrl}`;
        setSelectedFile({ ...file, url: fullUrl, type });
    };

    const handleCloseModal = () => {
        setSelectedFile(null);
    };

    const handleDeleteFile = (fileToDelete) => {
        setUploadedFiles(prev =>
            prev.filter(file => file?.fileUrl !== fileToDelete?.fileUrl)
        );

        // Optionally delete from server
        // dispatch(actions.DELETE_FILE({ id: fileToDelete._id }));
    };

    return (
        <Box display="flex" flexDirection="column" gap={3}>

            {getKraKpiAppraisalForm?.data?.employee_appraisal_score_editable && (
                <>
                    <input
                        id="file-upload"
                        type="file"
                        hidden
                        accept="image/*,application/pdf"
                        multiple
                        onChange={handleFileChange}
                    />

                    <label htmlFor="file-upload">
                        <Button
                            component="span"
                            variant="contained"
                            sx={{ background: "var(--main-color)", textTransform: "none"}}
                        >
                            Upload Documents
                        </Button>
                        <Typography variant="body1" sx={{fontSize:"12px", mb: 2 ,mt:1}}>
                            Upload only pdf and images

                        </Typography>
                    </label>
                </>
            )}

            {/* Image Previews */}
            {uploadedFiles?.some(file => file?.fileType === 'image') && (
                <Box>
                    <Typography variant="h6">Image Previews:</Typography>
                    <Box display="flex" flexWrap="wrap" gap={2} mt={1}>
                        {uploadedFiles
                            ?.filter(file => file?.fileType === 'image')
                            ?.map((img, index) => (
                                <Box
                                    key={index}
                                    position="relative"
                                    sx={{ width: 120, height: 120 }}
                                >
                                    <img
                                        src={`${adminUrl}${img?.fileUrl}`}
                                        alt={img?.fileName}
                                        onClick={() => handlePreviewClick(img, 'image')}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            borderRadius: 8,
                                            cursor: 'pointer',
                                        }}
                                    />
                                    {getKraKpiAppraisalForm?.data?.appraisal_current_status === "not started" && (


                                        <IconButton
                                            size="small"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleDeleteFile(img);
                                            }}
                                            sx={{
                                                position: 'absolute',
                                                top: 4,
                                                right: 4,
                                                backgroundColor: 'rgba(0,0,0,0.5)',
                                                color: 'white',
                                                '&:hover': { backgroundColor: 'rgba(0,0,0,0.7)' }
                                            }}
                                        >
                                            <DeleteIcon fontSize="small" />
                                        </IconButton>
                                    )}
                                </Box>
                            ))}
                    </Box>
                </Box>
            )}

            {/* PDF Previews */}
            {uploadedFiles?.some(file => file?.fileType === 'pdf') && (
                <Box>
                    <Typography variant="h6">PDF Previews:</Typography>
                    <Box display="flex" flexWrap="wrap" gap={2} mt={1}>
                        {uploadedFiles
                            ?.filter(file => file?.fileType === 'pdf')
                            ?.map((pdf, index) => (
                                <Box
                                    key={index}
                                    position="relative"
                                    sx={{ width: 120, height: 160, cursor: 'pointer' }}
                                    onClick={() => handlePreviewClick(pdf, 'pdf')}
                                >
                                    <iframe
                                        src={`${adminUrl}${pdf?.fileUrl}`}
                                        width="100%"
                                        height="100%"
                                        title={`PDF Preview ${index}`}
                                        style={{
                                            border: '1px solid #ccc',
                                            borderRadius: 8,
                                            pointerEvents: 'none',
                                        }}
                                    />
                                    {getKraKpiAppraisalForm?.data?.appraisal_current_status === "not started" && (

                                        <IconButton
                                            size="small"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleDeleteFile(pdf);
                                            }}
                                            sx={{
                                                position: 'absolute',
                                                top: 4,
                                                right: 4,
                                                backgroundColor: 'rgba(0,0,0,0.5)',
                                                color: 'white',
                                                '&:hover': { backgroundColor: 'rgba(0,0,0,0.7)' }
                                            }}
                                        >
                                            <DeleteIcon fontSize="small" />
                                        </IconButton>
                                    )}
                                </Box>
                            ))}
                    </Box>
                </Box>
            )}

            {/* Modal Preview */}
            <Dialog
                open={Boolean(selectedFile)}
                onClose={handleCloseModal}
                maxWidth="md"
                fullWidth
            >
                <DialogContent sx={{ position: 'relative' }}>
                    <IconButton
                        onClick={handleCloseModal}
                        sx={{ position: 'absolute', top: 8, right: 8, zIndex: 1 }}
                    >
                        <CloseIcon />
                    </IconButton>

                    {selectedFile?.type === 'image' ? (
                        <Box display="flex" justifyContent="center">
                            <img
                                src={selectedFile?.url}
                                alt={selectedFile?.fileName}
                                style={{ maxWidth: '100%', maxHeight: '80vh', borderRadius: 8 }}
                            />
                        </Box>
                    ) : (
                        <iframe
                            src={selectedFile?.url}
                            width="100%"
                            height="600px"
                            title={selectedFile?.fileName}
                            style={{ border: 'none' }}
                        />
                    )}
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default FileUploadWithPreview;
